<div class="pt-4 pb-4 pl-md-5 pr-md-5 masthead sticky-cover bg-white">
    <div class="row align-items-center">
        <div class="col col-md-6 col-lg-8">
            <p class="mb-0 h3 ellipsis">
                <i class="fa mr-3 fa-globe"></i>
                <a class="text-primary" routerLink="/countries"><strong>Countries</strong></a>
                <i class="fa fa-angle-right text-muted mr-2 ml-2"></i>
                <a class="text-primary" routerLink="/countries/{{itemConfigSet?.country?.code}}"><strong>{{itemConfigSet?.country?.shortName}}</strong></a>
                <i class="fa fa-angle-right text-muted mr-2 ml-2"></i>
                <span class="text">{{itemConfigSet?.itemConfigs[0].name}}</span>
            </p>
        </div>
        <div class="col text-right">
            <div class="btn btn-sm btn-outline-secondary" *ngIf="itemConfigSet.canSaveAndCancel" (click)="onCancel();">
                Cancel changes
            </div>
            <div class="btn btn-sm btn-primary ml-2" *ngIf="itemConfigSet.canSaveAndCancel" (click)="saveChanges();">
                Save to draft
            </div>
        </div>
    </div>
</div>

<div class="p-3 pl-md-5 pr-md-5 masthead bg-white sticky">
    <div class="row">
        <div class="col col-auto ml-auto">
            <div class="btn btn-outline-secondary" *ngIf="itemConfigSet.canSaveAndCancel" (click)="onCancel();">
                Cancel changes
            </div>
            <div class="btn btn-primary ml-2" *ngIf="itemConfigSet.canSaveAndCancel" (click)="saveChanges();">
                Save to draft
            </div>
        </div>
    </div>
</div>



<div class="row justify-content-between m-0 mh-100">
    <div class="col p-5 pt-sm-0">
        <div class="editable-content">
            <div class="row">
                <div class="col">
                    <div class="section pt-5 pb-5">
                        <itemconfigmanagementitem [item]="item" [dropdowns]="dropdowns" [liveItems]="[]" [items]="item?.children" [depth]="1" [statusId]="itemConfigSet.statusId" [canEdit]="itemConfigSet.canEdit">
                        </itemconfigmanagementitem>
                    </div>
                    <div class="mb-xl-5">&nbsp;</div>
                    <div class="mb-xl-5">&nbsp;</div>
                </div>
            </div>
        </div>
    </div>
    <div class="col col-md-4 drawer drawer-right" [ngClass]="{'drawer-closed': commentsHidden}" *ngIf="itemConfigSet.statusId == countryDataStatus.Draft">
        <div class="drawer-handle" (click)="toggleComments()"></div>
        <div class="drawer-contents p-md-5">
            <countrydatatimeline [events]="countryDataTimeline"
                                 [countryDataId]="itemConfigSet.countryDataId"
                                 [countryName]="itemConfigSet.country.shortName"
                                 [countryCode]="itemConfigSet.country.code"></countrydatatimeline>
        </div>
    </div>
</div>

<confirmationmodal #confirmModal (onAccept)="onAccept();"></confirmationmodal>